import { Flex, Text } from "@chakra-ui/react";
import { PieChart, Pie, Cell, Tooltip } from "recharts";
import { PieChartTooltip } from "./PieChartToolTip";
import { t } from "i18next";
import { CustomLabel } from "./CustomLabel";
import { pieChartProps } from "./shared";
import { observer } from "mobx-react-lite";
import { RiskFactor, Score } from "@keita/lanepatrol-sdk";
import { useCraScorePieCharts } from "../../hooks/useCraScorePieCharts";
import { tRiskFactor } from "../../../../coding/utils/score-utils";
import { useStores } from "../../../../shared/stores/RootStore";

interface Props {
  crashType: keyof Score;
}
const CraScorePieChartBase: React.FC<Props> = ({ crashType }) => {
  const { filterStore } = useStores();
  const data = useCraScorePieCharts(
    filterStore.filteredCraDistance,
    filterStore.filteredNodes,
  );

  if (!data)
    return (
      <Text fontSize="xs" alignSelf={"start"}>
        {t(`map:pieChart.noData`)}
      </Text>
    );

  const clockwiseData = [...data[crashType]].reverse();

  return (
    <Flex flexDirection="column" alignItems="center">
      <PieChart {...pieChartProps}>
        <Tooltip
          content={
            <PieChartTooltip translate={(s) => tRiskFactor(s as RiskFactor)} />
          }
        />

        <Pie
          nameKey="name"
          dataKey="value"
          label={CustomLabel}
          data={clockwiseData}
          outerRadius={72}
        >
          {clockwiseData.map((entry, i) => (
            <Cell key={i} fill={entry.color} />
          ))}
        </Pie>
      </PieChart>
    </Flex>
  );
};

export const CraScorePieChart = observer(CraScorePieChartBase);
